import React from "react";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import AddIcon from "@material-ui/icons/Add";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";

import RbActions from "components/RbActions";
import RbButtonAction from "components/RbButtonAction";
import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";
import RbScrollView from "components/RbScrollView";

import ProductsContent from "../ProductsContent";
import ProductsFilter from "../ProductsFilter";
import ProductsSearchParams from "../ProductsSearchParams";

function ProductsDesktop(props) {
  const { filters, onFilter, onSearch, searchParams } = props;

  const { pathname } = useLocation();

  const history = useHistory();

  const handleNew = React.useCallback(() => {
    history.push(`${pathname}/new`);
  }, [history, pathname]);

  return (
    <RbFlexView>
      <RbFlexViewItem bgcolor="custom.high">
        <RbHeader
          title="Products"
          actions={
            <RbActions>
              <RbButtonAction Icon={AddIcon} onClick={handleNew} text="New" />
            </RbActions>
          }
        >
          <Box pl={{ lg: 68 }} pb={{ md: 4 }}>
            <Container>
              <ProductsSearchParams onSearch={onSearch} />
            </Container>
          </Box>
        </RbHeader>
      </RbFlexViewItem>
      <RbFlexViewItem
        flex="1"
        bgcolor="custom.bg.50"
        borderTop={1}
        borderColor="custom.border.200"
      >
        <RbFlexView direction="row">
          <RbFlexViewItem flex="0 280px" bgcolor="custom.bg.100">
            <RbScrollView>
              <ProductsFilter onFilter={onFilter} filters={filters} />
            </RbScrollView>
          </RbFlexViewItem>
          <RbFlexViewItem flex="1">
            <RbScrollView pt={5} pb={5}>
              <ProductsContent filters={filters} searchParams={searchParams} />
            </RbScrollView>
          </RbFlexViewItem>
        </RbFlexView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

ProductsDesktop.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default React.memo(ProductsDesktop);
